<template>
  <div class="Tccc">
    <DraggableModal v-if="answerStatus.includes(TcccStatus)" />
    <a-modal
      v-if="visible"
      :footer="null"
      :visible="visible"
      :closable="false"
      :keyboard="false"
      @ok="handleOk"
      centered
      width="520px"
    >
      <template #title>
        <div class="modal-title">
          <div class="left">来电提醒</div>
          <!-- AI 电话的标识 -->
          <div v-if="data.AiOutbound.sceneStr" class="right">
            <span>{{ data.AiOutbound.sceneStr }}</span>
          </div>
          <div v-else class="right">
            <img class="img" width="18" height="18" src="@/assets/img/callIn-tip.png" alt="咨询" />
            <span>{{ data.intentTitle }}</span>
          </div>
        </div>
      </template>
      <div class="modal-body">
        <div class="flex">
          <AuthImg :src="userInfo.header || fallImg" alt="" :key="userInfo.userId" />
          <div class="info">
            <div style="margin-bottom: 4px">
              <span style="margin-right: 8px">{{ `${userInfo.userType}-${userInfo.name}` }}</span>
              <span class="call">来电</span>
            </div>
            <div v-if="userInfo.userType === '患者'">
              <span
                style="margin-right: 3px"
                v-if="userInfo.extendInfo?.gender || userInfo.extendInfo?.gender === 0"
              >
                {{ `${['女', '男'][userInfo.extendInfo?.gender]}` }}
              </span>
              <span v-if="userInfo.extendInfo?.age || userInfo.extendInfo?.age === 0">
                {{ ` ${userInfo.extendInfo?.age}岁` }}
              </span>
            </div>
            <div v-if="userInfo.userType === '医生'">{{ userInfo.extendInfo?.hospitalName }}</div>
            <div v-if="userInfo.userType === 'BD'">{{ userInfo.extendInfo?.dptName }}</div>
          </div>
        </div>
        <!-- 记录 （近3次服务）v-if="data.AiOutbound.sceneStr" -->
        <div class="history">
          <div class="title">最近通话记录：</div>
          <template v-if="data.latestList && data.latestList.length">
            <div v-for="item in data.latestList" :key="item.cdrId" class="content">
              <span class="item label">{{ directionEm[item.direction] }}</span>
              <!-- 呼出 -->
              <span class="item" v-if="item.direction">
                {{ roleEm[item.callerType] }}-{{ item.callerName }}
              </span>
              <!-- 接听 -->
              <span class="item" v-else>{{ roleEm[item.calleeType] }}-{{ item.calleeName }}</span>
              <span class="item">{{ item.acceptTime }}</span>
              <span class="item">{{ item.serviceScene }}</span>
            </div>
          </template>
          <div v-else class="content">暂无</div>
        </div>
        <!-- 上一次服务 -->
        <!-- <div v-else class="history">上次服务：{{ data.lastServeText || '--' }}</div> -->
        <div class="action">
          <div class="green" @click="handleOk">接听</div>
          <div class="red" @click="handleCancel">拒绝</div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script setup>
import fallImg from '@/assets/img/chat/head_p.png'
import DraggableModal from './DraggableModal.vue'
import AuthImg from '@/components/AuthImg'
import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import { hungUp, callIn } from '@/utils/Tccc'
import { prePatientSave } from '@/api/patientFile'
import { useServiceInfo } from './useTransferInfo'
import { directionEm, roleEm } from './config'

const answerStatus = ['Calling', 'Pending', 'Accept', 'RingOn']
const store = useStore()
const TcccStatus = computed(() => store.state.tccc.tcccStatus)
const visible = computed(() => store.state.tccc.tcccStatus === 'Answer')
const userInfo = computed(() => store.state.tccc.tcccUserInfo)

const handleOk = () => {
  callIn()
  handlePrePatient()
}

// 处理预患者/患者逻辑
const handlePrePatient = async () => {
  try {
    console.log('来电信息-------------', userInfo.value)
    const { userId, callerType, phone } = userInfo.value
    const telephone = phone && phone.substring(4)
    let patientId = userId
    // 未知用户调保存接口，新增患者预存档案获取id
    if (userId === 0 || !userId) {
      const params = {
        name: '未知用户',
        phone: telephone
      }
      const result = await prePatientSave(params)
      patientId = result.id
    }
    // 如果是预建档患者或者普通患者则弹出患者档案(未知用户默认弹出建档弹窗)
    if ([-1, 0, 1].includes(callerType)) {
      const param = {
        patientId,
        patientType: callerType === 1 ? 1 : 0
      }
      store.dispatch('patientFile/openModal', param)
    }
  } catch (error) {
    console.log(error)
  }
}

const handleCancel = () => {
  hungUp()
}
const { getTransferInfo, data } = useServiceInfo()
watch(visible, v => {
  if (!v) return
  console.log(`output->getTransferInfo`)
  getTransferInfo(true)
})
</script>
<style scoped lang="scss">
.flex {
  display: flex;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  img {
    width: 36px;
    height: 36px;
    border-radius: 4px;
  }
  .info {
    margin-left: 16px;
    .call {
      margin-left: 17px;
      color: #f84f4f;
    }
  }
}
.red {
  background: #f5222d;
  border-radius: 4px;
}
.green {
  background: #52c41a;
  border-radius: 4px;
}
.action {
  display: flex;
  color: #fff;
  align-items: center;
  flex-direction: row-reverse;
  padding-top: 30px;
  div {
    padding: 4px 16px;
    margin-left: 8px;
    cursor: pointer;
    letter-spacing: 3px;
  }
}
.modal-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
  }
  .right {
    border-radius: 14px;
    background: #fff3e6;
    padding: 5px 8px;
    color: #ff9411;
    .img {
      margin-right: 8px;
    }
  }
}
.modal-body {
  .history {
    padding: 12px;
    border-radius: 4px;
    background: #f6f7f8;
    padding: 8px 12px;
    margin-top: 20px;
    .title {
      font-weight: 500;
      font-size: 12px;
      color: #333333;
    }
    .content {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      margin-top: 10px;
      .label {
        padding: 3px 6px;
        font-size: 11px;
        border: 1px solid #c7cbd5;
        border-radius: 4px;
      }
      .item {
        margin-right: 6px;
      }
    }
  }
}
</style>
